import { Button, Card } from "@/components/atoms";
import { useAppDispatch } from "@/redux/hooks";
import { setAction } from "@/redux/slices/booking/bookingSlice";
import { BookingDetails } from "@/redux/slices/booking/types";
import { DetailField } from "../../common/DetailField";

interface TripSectionProps {
  booking: BookingDetails;
  showViewTripActivityButton?: boolean;
}

const ColoredDot = ({ className }: { className: string }) => (
  <div className="flex h-6 w-6 items-center justify-center">
    <div className={`h-[10px] w-[10px] rounded-full ${className}`} />
  </div>
);

export const TripSection = ({ booking, showViewTripActivityButton = true }: TripSectionProps) => {
  const dispatch = useAppDispatch();
  const { stops } = booking;
  const pickup = stops[0];
  const dropOff = stops[stops.length - 1];
  const intermediateStops = stops.slice(1, stops.length - 1);

  const totalStops = stops.length;
  const dashLineHeight = totalStops > 2 ? (totalStops - 1) * 56 : 56;

  const handleViewTripActivity = () => {
    dispatch(setAction("trip-activity"));
  };

  return (
    <Card className="relative overflow-hidden p-2.5">
      <div className="relative z-10 flex min-w-0 flex-col space-y-3">
        <DetailField
          leading={<ColoredDot className="bg-primary" />}
          label={pickup.city}
          value={pickup?.address}
          className="min-w-0"
          valueClassName="truncate min-w-0"
        />

        {intermediateStops.map((stop, index) => (
          <DetailField
            key={index}
            leading={<ColoredDot className="bg-neutral-silver-gray" />}
            label={stop.city}
            value={stop.address}
            valueClassName="truncate min-w-0"
            className="min-w-0"
          />
        ))}

        <DetailField
          leading={<ColoredDot className="bg-warning" />}
          label={dropOff.city}
          value={dropOff?.address}
          valueClassName="truncate min-w-0"
          className="min-w-0"
        />

        {showViewTripActivityButton && (
          <Button
            variant="tertiary-light"
            size="sm"
            endIcon="ArrowRight"
            onClick={handleViewTripActivity}
            className="hover:text-info-dark self-end text-info hover:bg-transparent"
          >
            View Trip Driver Activity
          </Button>
        )}
      </div>

      <div className="absolute left-[22px] top-[22px] z-0 flex w-0 items-center justify-center" style={{ height: `${dashLineHeight}px` }}>
        <div className="rotate-90 transform">
          <svg width={dashLineHeight} height="4" viewBox={`0 0 ${dashLineHeight} 4`} fill="none" className="block">
            <line x1="0" y1="2" x2={dashLineHeight} y2="2" strokeWidth="2" strokeDasharray="4 4" className="stroke-neutral-silver-gray" />
          </svg>
        </div>
      </div>
    </Card>
  );
};
